const overview = {
	bttn_create: "Tuxis daDup aanmaken",
	card: {
		body: {
			datastore_name: "Datastore naam",
			description: "Omschrijving",
			free_version: "Gratis versie",
			hostname: "daDup host",
			in_use: "In gebruik",
			location: "Serverlocatie",
			name: "Weergave-naam",
			new: "Recent aangemaakt",
			username: "Gebruikersnaam",
		},
		footer: {
			bttn: "Toon details",
		},
	},
	empty: "U hebt nog geen Tuxis daDup account",
	title: "Tuxis daDup overzicht",
};

const cancelDialog = {
	description:
		"Wanneer u deze dienst opzegt zal deze worden beëindigt en wordt de data definitief verwijderd. Ter bevestiging vragen we u om de naam van de daDup <strong>{{username}}</strong> hieronder te herhalen",
	label: "Gebruikersnaam",
	placeholder: "De gebruikersnaam waar mee u op dadup inlogt.",
	submit_button: "Verwijder daDup account",
	success_message: "daDup succesvol opgezegd!",
	title: "Dadup account verwijderen",
};

const page = {
	current_usage: {
		in_use: "Momenteel in gebruik",
		title: "Actueel verbruik",
	},
	delete_button: "Dadup opzeggen",

	info_tile: {
		description: "Omschrijving",
		host: "daDup Host",
		location: "Server locatie",
		name: "Weergave-naam",
		relation_title: "Gekoppelde relatie",
		title: "daDup informatie",
		username: "Gebruikersnaam",
	},
	password_tile: {
		credentials_saved_button: "Ik heb de gegevens opgeslagen",
		description:
			"De inloggegevens staan <strong>30 dagen</strong> in de wachtwoordkluis. Sla deze gegevens op in uw eigen wachtwoordmanager.",
		description_completed:
			"De inloggegevens uit de wachtwoordkluis hebt u opgeslagen in uw wachtwoordmanager.",
		password_vault_button: "Naar wachtwoordkluis",
		request_credentials: "Gegevens verloren? Vraag nieuwe credentials aan.",
		title: "Dadup inloggegevens",
	},
	title: "Tuxis daDup account informatie",
};
const bucket = {
	add_button: "Bucket toevoegen",
	create_dialog: {
		description: "Deze maakt een bucket aan binnen uw daDup account, kies een passende naam.",
		label: "Bucket naam",
		placeholder: "Bijv. bucket01",
		success: "Succesvol bucket aangevraagd! Dit kan enkele minuten duren.",
		title: "Bucket toevoegen",
	},
	delete_dialog: {
		description:
			"Wanneer u deze bucket <strong>{{name}}</strong> verwijderd wordt alle data definitief verwijderd en kan je deze actie niet terug draaien. Weet u het zeker?",
		label: "Bucket naam",
		placeholder: "De naam van de Bucket",
		submit: "Verwijder bucket",
		success: "Bucket succesvol verwijderd!",
		title: `Bucket '{{name}}' verwijderen`,
	},
	table: {
		title: "Buckets",
	},
};

const table = {
	created_at: "Aanmaak datum",
	display_name: "Display naam",
	id: "ID",
	label: "Label",
	order_code: "Order code",
	relation: "Relatie",
	table_items: {
		Ceph: "Ceph",
		s3: "S3",
	},
	type: "Soort Dadup account",
	username: "Gebruikers naam",
};

const manage = {
	bucket: bucket,
	cancel_dialog: cancelDialog,
	mange: "Manage Dadup",
	overview: overview,
	page: page,
	table: table,
};

export default manage;
